import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import Select from '../common/form/select';

import { setModoEntrada } from './brindeActions';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return 0;
    }

    const texto = valor.toString().trim();
    const possuiSeparadorMilhar =
        /^-?\d{1,3}(\.\d{3})+$/.test(texto);
    const textoNormalizado =
        texto.includes(',') || possuiSeparadorMilhar
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto;
    const resultado = Number(textoNormalizado);

    return Number.isFinite(resultado) ? resultado : 0;
};

let BrindeEntradaForm = props => {
    const formulario = props.formulario || {};
    const readOnly = props.excluir ? 'readOnly' : '';
    const valorTotal =
        numero(formulario.quantidade) *
        numero(formulario.valor_unitario);

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Row>
                        <Field
                            name='datahora_entrada'
                            component={LabelAndInput}
                            type='datetime-local'
                            label='Data e hora *'
                            cols='12 4 3 3'
                            readOnly={readOnly}
                        />
                        <Field
                            name='id_fornecedor'
                            component={Select}
                            options={props.fornecedores}
                            label='Fornecedor *'
                            cols='12 8 5 5'
                            readOnly={readOnly}
                        />
                    </Row>
                    <Row>
                        <Field
                            name='id_produto'
                            component={Select}
                            options={props.brindes}
                            label='Brinde *'
                            cols='12 5 4 4'
                            readOnly={readOnly}
                        />
                        <Field
                            name='quantidade'
                            component={LabelAndInputNumber}
                            label='Quantidade *'
                            casas={0}
                            cols='12 3 2 2'
                            readOnly={readOnly}
                        />
                        <Field
                            name='valor_unitario'
                            component={LabelAndInputNumber}
                            label='Valor unitário *'
                            casas={2}
                            cols='12 3 2 2'
                            readOnly={readOnly}
                        />
                        <LabelAndInputNumber
                            name='valor_total'
                            label='Valor total'
                            value={valorTotal}
                            casas={2}
                            cols='12 4 3 3'
                            readOnly='readOnly'
                            onChange={() => {}}
                        />
                    </Row>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoEntrada('lista')
                                }
                            />
                        </Grid>
                        <Grid cols='6 6 4 3'>
                            {props.excluir
                                ? <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />
                                : <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

BrindeEntradaForm = reduxForm({
    form: 'brindeEntradaForm',
    destroyOnUnmount: false
})(BrindeEntradaForm);

const mapStateToProps = state => ({
    formulario: getFormValues('brindeEntradaForm')(state),
    fornecedores: state.brinde.fornecedores,
    brindes: state.brinde.brindes
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoEntrada
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrindeEntradaForm);
